module.exports = __webpack_public_path__ + "static/bar04_1_mobile-9ac12fb95f6855fb548fb2554bcdb774.png";